/** @jsxImportSource react */
import { Box, CircularProgress } from '@mui/material'

const Loading = ({ fullScreen = false }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: fullScreen ? '100vh' : 200,
    }}
  >
    <CircularProgress size={28} />
  </Box>
)

export default Loading
